import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import { institutionalTypeService } from "../../../services/institutionalType.service";
import CustomTextInput from "../../../components/CustomTextInput";

export default function InstitutioanlTypeForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: institutionalTypeService.findById,
    queryKey: ["institutional-type"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: institutionalTypeService,
    form: form,
    messageApi: messageApi,
    queryKey: "institutional-type",
    route: "/master-data/institutional-type",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Jenis Lembaga"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/institutional-type"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Jenis Lembaga"
            name="name"
            rules={[{ required: true, message: "Jenis Lembaga harus diisi" }]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
